import { Days } from './types'

const DAYS: Days[] = [
  Days.monday,
  Days.tuesday,
  Days.wednesday,
  Days.thursday,
  Days.friday,
  Days.saturday,
  Days.sunday
]

export { DAYS }
